import '@material-design-icons/font/round.css';
import type { ThemeDefinition, VuetifyOptions } from 'vuetify';
import 'vuetify/styles';

const ContractsLight: ThemeDefinition = {
    dark: false,
    colors: {
        'background': '#ffffff',
        'surface': '#f4f5f6',
        'primary': '#000000',
        'primary-button': '#000000',
        'error': '#d83d32',
        'info': '#045dff',
        'success': '#0a893c',
        'warning': '#f79009',
        'anchor': '#000000',
        'border-light': '#d0d5dd',
    },
};

const getVuetifyConfig = (options?: {
    theme?: boolean;
}): VuetifyOptions => {
    const _options = options ?? {
        theme: false,
    };

    const vuetifyTheme = {
        defaultTheme: 'ContractsLight',
        themes: { ContractsLight },
    };

    return {
        theme: _options.theme ? vuetifyTheme : false,
        defaults: {
            VBtnPrimary: {
                VProgressCircular: {
                    size: '24',
                },
            },
            VDataTable: {
                class: 'border rounded bg-background',
                sortAscIcon: 'arrow_drop_up',
                sortDescIcon: 'arrow_drop_down',
            },
            VProgressCircular: {
                size: '64',
            },
            VSelect: {
                density: 'default',
                variant: 'outlined',
            },
            VTextField: {
                density: 'default',
                variant: 'outlined',
            },
        },
    };
};

export { getVuetifyConfig };
